import * as actionTypes from './actionTypes';

export const updateHomepageReducer = (payload) => {
  return {
    type: actionTypes.UPDATE_MOBILE_HOMEPAGE_DATA,
    payload,
  };
};
